/* eslint-disable @typescript-eslint/no-unused-vars */
const markDefs = `
  defined(markDefs[]) => {
  markDefs[]{
    ...,
    _type == "internalLink" => {
      "slug": @.page->slug,
      "parent": @.page->link->,
    },
    _type == "asset" => {
      ...,
      "fileURL": @.linkedAsset->asset.asset->url
    },
  }
  }`;

const imageQueryMin = `
  "url": asset->url,
  "alt": alt,
  "metaData": asset->metadata {
    dimensions {
      width,
      height,
      aspectRatio
    }
  }  
`;

const imageQueryMetaData = `
  "meta":asset->metadata{
    dimensions {
      width,
      height,
      aspectRatio
    }
  }
`;

export const campaignQuery = `
 referencedCampaign -> {
    apiId,
    callToActionText,
    callToActionTitle,
    daysOfValidity,
    detailedText,
    saleStartAt,
    endAtUtc,
    launchAtUtc,
    price,
    "image": image{
      ${imageQueryMin}
    },
    reportRef,
    ticketInfoText,
    title,
    "bgColor": primaryColor->color.hex,
    "secondaryColor": secondaryColor->color.hex,
  },
`;

const linkInternal = `
  coalesce(articleLink.internal->{slug{current}, "parentLink": link->slug{current}}, link.linkInternal->{slug{current}, "parentLink": link->slug{current}})
`;

const articleBoxQuery = `
  referencedArticleBox->{
    "text": text,
    "heading": heading,
    "linkText": linkText,
    "linkInternal": ${linkInternal},
    "linkExternal": coalesce(articleLink.external, link.linkExternal),
    "image": image{
      ${imageQueryMin}
    },
  },
`;

const infoBoxQuery = `
  defined(referencedInfoBox) => {
    referencedInfoBox->{
      "heading": heading,
      "bgColor": bgColor->color.hex,
      "image": image{
        ${imageQueryMin}
      },
      "body": infoBoxText[]{
        ...,
        ${markDefs}
      },
    },
  },
`;

const twoColumnsQuery = `
  defined(twoColumnSections[]) => {
    twoColumnSections[]->{
      ...,
      "bgColor": bgColor->color.hex,
      "linkInternal": ${linkInternal},
      "linkExternal": coalesce(articleLink.external, link.linkExternal),
      "image": image{
        ${imageQueryMin}
      },
      infoBoxText[]{
        ...,
        ${markDefs}
      },
    },
  },
`;

const threeColumnsQuery = `
  defined(threeColumnSections[]) => {
    threeColumnSections[]{
      "linkInternal": ${linkInternal},
      "linkExternal": coalesce(articleLink.external, link.linkExternal),
      "title": title,
      "text": text,
      "image": image{
        ${imageQueryMin}
      },
    },
  },
`;

const stationSearch = `
  defined(referencedFromStation) => {
      "fromStation": referencedFromStation->{
        name,
        id,
      },
  },
  defined(referencedToStation) => {
      "toStation": referencedToStation->{
        name,
        id,
      },
  },
`;

const imageQuery = `
  "url": asset->url,
  "alt": alt,
  "caption": caption,
  "copyright": copyright,
  "copyrightColor": copyrightColor->color.hex,
  "displayOnPage": displayOnPage,
  "metaData": asset->metadata {
    dimensions {
      width,
      height,
      aspectRatio
    }
  }  
`;

const videoQuery = `
  defined(asset.asset) => {
    "video": {
      "url": asset.asset->url,
      "alt": alt,
      "caption": caption,
    },
  },
`;

const youtubeQuery = `
  defined(url) => {
    "youtube": {
      "url": url,
    },
  },
`;

const googleTagManagerCookieInfoInjectorQuery = `
  defined(info) => {
    "googleTagManagerCookieInfoInjector": {
      "info": info,
    },
  },
`;

const mainImageQuery = `
  "mainImage": mainImage{
    ${imageQuery}
  },
`;

export const pageQuery = `
        ...,
        defined(mainImage) => {
          ${mainImageQuery}
        },
        defined(referencedCampaign) => {
          ${campaignQuery}
        },
        "parentLink": link->slug{current},
        body[]{
          ...,
          defined(image.asset) => {
            "url": image.asset->url,
            "imageMeta": image{   
              ${imageQueryMetaData}
            }
          },
          defined(copyrightColor) => {       
            "copyrightColor": copyrightColor->color.hex,
          },
          ${twoColumnsQuery}
          ${threeColumnsQuery}
          ${stationSearch}
          ${videoQuery}
          ${youtubeQuery}
          ${googleTagManagerCookieInfoInjectorQuery}
          defined(referencedCampaign) => {
            ${campaignQuery}
          },
          ${infoBoxQuery}
          defined(referencedArticleBox) => {
            ${articleBoxQuery}
          },
          ${markDefs}
        },
        'locales': *[_type == "translation.metadata" && references(^._id)].translations[].value->{
          'locale': language, 
          'slug': slug.current 
        }, 
      }`;

export const partnerPageQuery = `
        ...,
        'notLoggedIn': notLoggedIn{
          ...,
          body[]{
            ...,
          defined(image.asset) => {
            "url": image.asset->url,
            "imageMeta": image{   
              ${imageQueryMetaData}
            }
          },
          defined(copyrightColor) => {
            "copyrightColor": copyrightColor->color.hex,
          },
          ${twoColumnsQuery}
          ${threeColumnsQuery}
          ${stationSearch}
          ${videoQuery}
          ${youtubeQuery}
          ${googleTagManagerCookieInfoInjectorQuery}
          defined(referencedCampaign) => {
            ${campaignQuery}
          },
          ${infoBoxQuery}
          ${articleBoxQuery}
          ${markDefs}
          },
        },
        'loggedIn': loggedIn{...},
        'locales': *[_type == "translation.metadata" && references(^._id)].translations[].value->{
          'locale': language, 
          'slug': slug.current 
        }, 
      }`;

export const landingPageQuery = `
  title,
  language,
  slug,
  "tag": tag->.name,
  apiId,
  "subPages":coalesce(
    articlePage[]->{
      "id": _id,
      "heading": title, 
      "text": preamble, 
      "image": mainImage{${imageQuery}},
      publishAt,
      unpublishAt,
      "linkText": title,
      "linkInternal": {
        "parentLink": link->slug{current},
        slug,
      },
    }, 
    standardPage[]->{
      title,
      slug,
      externalLink,
      apiId,
      "assetLink": asset.asset->url,
    },
  ),
  'locales': *[_type == "translation.metadata" && references(^._id)].translations[].value->{
    'locale': language, 
    'slug': slug.current 
  }
}`;
